document.addEventListener('DOMContentLoaded', () => {
	attachListeners();

	const targetElement = document.querySelector('.collection__dynamic-part');
	const observer = new MutationObserver(() => {
		attachListeners();
	});
	observer.observe(targetElement, { childList: true });
});

function attachListeners() {
	document.querySelectorAll('.product-list .product-item__action-button.button--ternary').forEach((button) => {
		button.addEventListener('click', () => {
			const productId = button.nextElementSibling.value;

			const polling = setInterval(() => {
				const atcButton = document.querySelector(".modal:not(.is-loading)[aria-hidden='false'] .product-form__add-button");
				if (atcButton) {
					clearInterval(polling);

					const atcContainer = atcButton.closest('.product-form__buy-buttons');
					const newHulkContainer = document.createElement('div');
					newHulkContainer.id = `hulkapps_custom_options_${productId}`;
					atcContainer.prepend(newHulkContainer);

					const $ = window.hulkapps_jQuery;
					window.hulk_add_to_cart_ele = $(atcButton);
                    window.hulkapps.product = {};
					window.hulkapps.product_id = productId;
					window.hulkapps.page_type = 'product';
					window.productPageAjax($);
				}
			}, 100);
		});
	});
}